<template>
  <div>
    <treeselect
      v-model="value"
      :multiple="false"
      :cacheOptions="false"
      :defaultExpandLevel='2'
      :normalizer="typeIdsNormalizer"
      :placeholder="placeholder"
      :options="option"
      :alwaysOpen="alwaysOpen"
      :searchable="true"
      :disabled="admin!='admin'&&disabled"
      @select="select"
       @input="input"
    />
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  mounted() {
    this.admin=sessionStorage.getItem("admin")
    // console.log(this.option);
  // console.log(this.treeValue)
    //数据处理
    // this.treeValue!=null?this.getValue():''
    this.value=this.treeValue
      // this.detailChange();
  },
   props: {
    option: {
      type: Array,
      default(){
        return []
      }
    },
    treeValue: {
      type: Number,
      default(){
        return null
      }
    },
    alwaysOpen: {
      type: Boolean,
      default(){
        return false
      }
    },
    disabled: {
      type: Boolean,
      default(){
        return true
      }
    },
    placeholder:{
      type:String,
      default(){
        return '请输入...'
      }
    }
   },
  components: { Treeselect },
  data() {
    return {
      admin:'',
      typeIdsNormalizer(node) {
        // console.log(node);
        // 自定义派单大小类树键名
        return {
          id: node.id,
          label: node.name
        };
      },
      value: null,
      // define options
      options: []
    };
  },
  methods: {
    select(node, instanceId) {
      this.$emit("treeValue", node.id);
       this.$emit("treeValueLevel", node.level);
        this.$emit("treeValueParentId", node.id);
        this.$emit("treeAll", node);
      // console.log(node.code);
    },
     input(node, instanceId){
      this.$emit("treeAllInput", node);
       if(node==undefined){
        this.$emit("reset", '');
      }
    //  console.log(node)
   },
    //数据处理
    detailChange() {
      var obj = [];
      var need = [];
      var last = this.option.length;
      var arr = JSON.parse(JSON.stringify(this.option));
      for (var j = 0; j < last; j++) {
        //控制次数
        for (var i = 0; i < arr.length; i++) {
          //每次循环筛选
          if (arr[i].level == j) {
            obj[j] = obj[j] ? obj[j] : [];
            obj[j].push(arr[i]);
          }
        }
      }
      need = obj;
      // console.log(need);
      for (var k = obj.length - 1; k > 0; k--) {
        for (var x = 0; x < obj[k].length; x++) {
          for (var y = 0; y < obj[k - 1].length; y++) {
            if (obj[k][x].parentId == need[k - 1][y].id) {
              need[k - 1][y].children = need[k - 1][y].children
                ? need[k - 1][y].children
                : [];
              need[k - 1][y].children.push(obj[k][x]);
            }
          }
        }
      }
      this.options = need[0];
      // console.log(this.options);
    },
    getValue(){
      this.option.forEach(elem=>{
        if(this.treeValue==elem.code){
          this.value=elem.id
        }
      })
    }
  }
};
</script>

<style scoped>
</style>